// extracted by mini-css-extract-plugin
export default {"line":"e_7K97to84l875Spvrlk__line___","horizontal":"tMPPRv_LAAdX1pmmGqHC__horizontal___","vertical":"P04mGjilGuYeC2EVw5L0__vertical___"};